import { lazy } from 'react';

const Employees = lazy(() => import('./Employees'));

export default Employees;
